module.exports = __webpack_public_path__ + "img/sutd-hoodie-design.9113966b.svg";